<app-navbar></app-navbar>
<router-outlet class="container"></router-outlet>

